<template>
<div v-if="!withAvilableCart">Shopping Cart empty.</div>
  <div v-else>
    <div>
      <div tabindex="0" class="e-card">
        <div class="e-card-title">My Shopping Cart</div>
        <div style="padding:20px">
          <div>
            <h4 class="title-color">Shopping Cart Information</h4>
          </div>
          <div class="e-card-separator"></div>
          <div class="wrap_address">
            <div class="form-row">
              <div style="width: 50%" class="form-row-input">
                <ejs-numerictextbox
                    float-label-type="Always"
                    placeholder="Total Amount*"
                    format = 'C2'
                    :showSpinButton = 'spin'
                    readonly = "true"
                    v-model="shoppingCart.totalShoppingAmount" />
              </div>
            </div>
            <div class="form-row">
              <div style="width:15%">
                <p style="color: black; font-size: 12px">Available Payment Methods:</p>
              </div>
              <div style="width:75%" class="form-row">
                 <div
                    style="width:15%"
                    v-for="(payMethod, index) in paymentMethods"
                    :key="index"
                >
                    <ejs-radiobutton
                    :label="payMethod.method"
                    :htmlAttributes="{ value: payMethod.method }"
                    :checked="
                        shoppingCart.checkOutMethod === payMethod.method
                    "
                    v-model="shoppingCart.checkOutMethod"
                    name="pmethod"
                    ></ejs-radiobutton>
                </div>
              </div>
              <div v-if="shoppingCart.totalShoppingAmount>=4000">
                 <p style="color: red; font-size: 12px">
                  Unfortunately, you have exceeded the credit card limit per transaction.
                  <br>You may select EFT or Cheque as a payment type and follow up with
                  our accounting department directly for further
                  information at accounting@safetycodes.ab.ca or 1-888-413-0099
                  </p>
              </div>
            </div>
            <div class="form-row">
                <ejs-grid :dataSource="invoices"
                    ref="refShoppingCartList"
                    enablePersistence='true'
                    :allowSorting="true"
                    :allowPaging="true"
                    :pageSettings="pageSettings"
                    :commandClick="commandClick"
                    >
                    <e-columns>
                        <e-column field="invoiceId"
                        headerText="Invoice ID" textAlign="Left"
                        :isPrimaryKey="true" width=0></e-column>
                       <e-column headerText="Remove"
                        :commands="commands"
                        textAlign="Left"
                        width=" 10%"></e-column>
                        <e-column field="invoiceNumber"
                        headerText="Invoice Number" textAlign="Left"></e-column>
                        <e-column field="invoiceSourceType"
                        headerText="Invoice Type" textAlign="Left"
                        width="15%"
                        ></e-column>
                        <e-column field="invoiceStatus"
                        headerText="Status" textAlign="Left"></e-column>
                        <e-column field="totalAmount"
                        headerText="Total Fee" format='C2' textAlign="Left"></e-column>
                        <e-column field="totalLevy"
                        headerText="Total Levy" format='C2' textAlign="Left"></e-column>
                        <e-column field="invoiceDate"
                        headerText="Invoice Date" textAlign="Left"
                        type="date" format="MMM dd, yyyy"></e-column>
                    </e-columns>
                </ejs-grid>
            </div>
          </div>
          <div class="align-center-bottom">
            <ejs-button
              type="button"
              v-on:click.native="onCheckoutClick"
              v-show="isAvailableToCheckOut"
              cssClass="e-info margin-button"
              >Check Out</ejs-button
            >
            <ejs-button
              type="button"
              v-on:click.native="onBackButtonClick"
              cssClass="e-danger margin-button"
              >Back to My Financial Transactions</ejs-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import {
  GridPlugin,
  Page,
  Toolbar,
  Edit,
  CommandColumn,
  Sort,
  Search,
} from '@syncfusion/ej2-vue-grids';
import {
  TextBoxPlugin,
  NumericTextBoxPlugin,
} from '@syncfusion/ej2-vue-inputs';
import { ButtonPlugin, RadioButtonPlugin } from '@syncfusion/ej2-vue-buttons';
import { DialogUtility } from '@syncfusion/ej2-popups';
import {
  FETCH_SHOPPING_CART_BY_USER_ID,
  FETCH_SHOPPING_CART_PAYMENT_METHODS,
  REMOVE_INVOICE_FROM_SHOPPING_CART,
  POST_SHOPPING_CART,
} from '../store';
// import SccInputValidator from '../../../components/base/scc-input-validator.vue';

Vue.use(GridPlugin);
Vue.use(TextBoxPlugin);
Vue.use(RadioButtonPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(ButtonPlugin);
Vue.use(DialogUtility);

export default {
  name: 'ShoppingCart',
  components: {
    // SccInputValidator,
  },
  data() {
    return {
      spin: false,
      pageSettings: { pageSize: 10 },
      toolbarOptions: ['Search'],
      invoiceToRemove: null,
      DialogObj: null,
      commands: [
        {
          type: 'Delete',
          buttonOption: {
            cssClass: 'e-flat deletebtn',
            iconCss: 'e-delete e-icons',
          },
        },
      ],
    };
  },
  created() {
    this.getShoppingCartByUserId();
    this.getPymentMethods();
  },
  computed: {
    userId() {
      return this.$store.getters.loggedUser ? this.$store.getters.loggedUser.id : null;
    },
    shoppingCart() {
      return this.$store.getters.getShoppingCartByUserId;
    },
    invoices() {
      const invs = [];
      this.shoppingCart.shoppingCartItems.forEach((element) => {
        invs.push(element.cartInvoice);
      });
      return invs;
    },
    withAvilableCart() {
      return !!this.shoppingCart;
    },
    paymentMethods() {
      return this.$store.getters.getShoppingCartPaymentMethods;
    },
    isAvailableToCheckOut() {
      return this.shoppingCart.totalShoppingAmount > 0;
    },
  },
  watch: {
    userId(val) {
      if (val) {
        this.getShoppingCartByUserId();
        this.getPymentMethods();
      }
    },
  },
  methods: {
    notify(type, message) {
      this.$parent.$parent.notificationToasts.push({
        title: type,
        content: message,
        cssClass: type === 'Error' ? 'e-toast-danger' : 'e-toast-success',
        timeOut: 5000,
      });
      if (this.$parent.$parent.notificationToasts.length > 0) {
        this.$parent.$parent.$refs.notifierRef.show();
      }
    },
    onCancelClick() {
      this.DialogObj = DialogUtility.confirm({
        title: 'Cancel Payment',
        content:
          'Are you sure you want to cancell payment process?<br> if you want pay it later, you still can.',
        okButton: { text: 'OK', click: this.cancelProcess },
        cancelButton: { text: 'Cancel', click: this.hideDeleteDialog },
        showCloseIcon: true,
        closeOnEscape: true,
        animationSettings: { effect: 'Zoom' },
      });
    },
    async onCheckoutClick() {
      const data = this.shoppingCart;
      await this.$store.dispatch(POST_SHOPPING_CART, data);
      this.$router.push('/financials/checkout');
    },
    cancelProcess() {
      this.DialogObj.hide();
    },
    onBackButtonClick() {
      this.$router.push('/reports/transactions');
    },
    async getShoppingCartByUserId() {
      try {
        if (this.userId !== null && this.userId !== '' && this.userId !== 'undefined') {
          const { userId } = this;
          if (userId) {
            await this.$store.dispatch(FETCH_SHOPPING_CART_BY_USER_ID, userId);
          }
        }
      } catch (error) {
        this.notify('Error', error.message);
      }
    },
    async getPymentMethods() {
      try {
        await this.$store.dispatch(FETCH_SHOPPING_CART_PAYMENT_METHODS);
      } catch (error) {
        this.notify('Error', error.message);
      }
    },
    async commandClick(args) {
      const invoice = args.rowData;
      // eslint-disable-next-line default-case
      switch (args.commandColumn.type) {
        case 'Delete':
          this.invoiceToRemove = invoice;
          this.DialogObj = DialogUtility.confirm({
            title: 'Remove Invoice From Shopping Cart',
            content: 'Are you sure you want to remove this invoice?',
            okButton: { text: 'OK', click: this.removeInvoice },
            cancelButton: { text: 'Cancel', click: this.hideDeleteDialog },
            showCloseIcon: true,
            closeOnEscape: true,
            animationSettings: { effect: 'Zoom' },
          });
          break;
      }
    },
    async removeInvoice() {
      const { invoiceId } = this.invoiceToRemove;
      await this.$store.dispatch(REMOVE_INVOICE_FROM_SHOPPING_CART, invoiceId)
        .then(() => {
          this.hideDeleteDialog();
        })
        .catch((error) => {
          console.error(`postapplication_err:${error.Status}`);
          this.hideDeleteDialog();
          DialogUtility.alert(error.message);
        });
      await this.getPymentMethods();
      await this.getShoppingCartByUserId();
    },
    hideDeleteDialog() {
      this.DialogObj.hide();
    },
  },
  provide: {
    grid: [Page, Edit, Toolbar, CommandColumn, Sort, Search],
  },
};
</script>
<style>
@import "../../../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css";
@import "../../../assets/styles/eservices-base.css";
.scc-logo {
  float: left;
}
.header-text {
  text-align-last: center;
  padding: 13px 130px 8px 8px;
}
</style>
